module.exports = __webpack_public_path__ + "media/assets/images/SYB-promo-xmas-ef7f6e76c3b922d111c8946db3edf2bb.jpg";